module.exports = __webpack_public_path__ + "img/img_analyist_suri_lg.ce5bfd28.png";